import { render } from "./TabellaContextMenu.vue?vue&type=template&id=109da782&ts=true"
import script from "./TabellaContextMenu.vue?vue&type=script&lang=ts"
export * from "./TabellaContextMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__